<div class="page-layout carded fullwidth inner-scroll">
    <h2>ID : {{id}}</h2>
    <div class="top-bg accent"> </div>
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
    </div>

    <div class="center">

        <form>
            <h2>ID : {{id}}</h2>
            <textarea id="mymce1">
                Norma 35
                <h2>ID : {{id}}</h2>
                <h1>Datita {{dataId.id}} </h1>
            </textarea>
            <div class="container">
                <button mat-raised-button color="primary">Publicar</button>
            </div>
        </form>
        <div fusePerfectScrollbar>
        </div>
    </div>
    <!-- / CONTENT HEADER -->


</div>